import { ApiError } from '@/lib/api/errors';
import { dedupeMessages, type ValidationDetail } from '@/lib/validation/server-details';

import { AUTH_ERROR_CODES } from './constants';

export const AUTH_ERROR_COPY: Record<string, string> = {
  [AUTH_ERROR_CODES.INVALID_CREDENTIALS]: 'Invalid phone number or password',
  [AUTH_ERROR_CODES.ACCOUNT_TEMPORARILY_LOCKED]:
    'Account temporarily locked. Try again after 30 minutes.',
  [AUTH_ERROR_CODES.RATE_LIMIT_EXCEEDED]: 'Too many attempts, try again later',
  [AUTH_ERROR_CODES.OTP_INVALID]: 'Please enter a valid verification code.',
  [AUTH_ERROR_CODES.SESSION_EXPIRED]: 'Your session has expired. Please log in again.',
  [AUTH_ERROR_CODES.RESEND_COOLDOWN_ACTIVE]:
    'Please wait for the countdown to finish before requesting another OTP.',
  [AUTH_ERROR_CODES.INVALID_PHONE_NUMBER]: 'Enter a valid 10-digit US phone number.',
  [AUTH_ERROR_CODES.USER_NOT_FOUND]: 'No account found with this phone number.',
  [AUTH_ERROR_CODES.INVALID_REFRESH_TOKEN]: 'Your session has expired. Please log in again.',
  [AUTH_ERROR_CODES.RESET_TOKEN_EXPIRED]:
    'Your verification session has expired. Please start again.',
  [AUTH_ERROR_CODES.INVALID_TOKEN]: 'Your session has expired. Please log in again.',
  [AUTH_ERROR_CODES.PASSWORD_MUST_BE_DIFFERENT]:
    'New password cannot be the same as your previous password.',
};

const GENERIC = 'Something went wrong. Please try again.';

export function authErrorMessage(error: unknown): string {
  if (error instanceof ApiError) {
    // A VALIDATION_FAILED 400 carries a generic top-level message ("The request payload is
    // invalid."); the reason the user can act on is in `details[]` (ADO 121341).
    if (
      error.code === AUTH_ERROR_CODES.VALIDATION_FAILED &&
      Array.isArray(error.details) &&
      error.details.length
    ) {
      return dedupeMessages(error.details as ValidationDetail[]).join(' ');
    }
    if (error.hasServerMessage) return error.message;
    if (error.code && AUTH_ERROR_COPY[error.code]) return AUTH_ERROR_COPY[error.code];
    return GENERIC;
  }
  return GENERIC;
}
